import { render } from "./orthopedic_list.vue?vue&type=template&id=2938e1a6&scoped=true"
import script from "./orthopedic_list.vue?vue&type=script&lang=js"
export * from "./orthopedic_list.vue?vue&type=script&lang=js"

import "./orthopedic_list.vue?vue&type=style&index=0&id=2938e1a6&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2938e1a6"]])

export default __exports__